import { ProblemDefinition } from './types';

const schemaDDL = `
CREATE TABLE departments (id INTEGER PRIMARY KEY, name TEXT NOT NULL, budget REAL);
CREATE TABLE employees (id INTEGER PRIMARY KEY, first_name TEXT NOT NULL, last_name TEXT NOT NULL, dept_id INTEGER, salary REAL, hire_date TEXT, manager_id INTEGER, FOREIGN KEY(dept_id) REFERENCES departments(id), FOREIGN KEY(manager_id) REFERENCES employees(id));
`;

const seedDML = `
INSERT INTO departments (id, name, budget) VALUES
  (1, 'Engineering', 500000),
  (2, 'Sales', 300000),
  (3, 'Marketing', 200000),
  (4, 'HR', 150000);

INSERT INTO employees (id, first_name, last_name, dept_id, salary, hire_date, manager_id) VALUES
  (1, 'Alice', 'Johnson', 1, 95000, '2020-03-15', NULL),
  (2, 'Bob', 'Smith', 1, 88000, '2021-06-01', 1),
  (3, 'Carol', 'Williams', 2, 72000, '2019-11-20', NULL),
  (4, 'David', 'Brown', 2, 65000, '2022-01-10', 3),
  (5, 'Eva', 'Davis', 3, 78000, '2020-07-22', NULL),
  (6, 'Frank', 'Miller', 1, 92000, '2018-09-05', 1),
  (7, 'Grace', 'Wilson', NULL, 60000, '2023-02-14', NULL),
  (8, 'Henry', 'Taylor', 3, 70000, '2021-04-30', 5),
  (9, 'Ivy', 'Anderson', 4, 67000, '2022-08-18', NULL),
  (10, 'Jack', 'Thomas', NULL, 55000, '2023-05-01', NULL);
`;

export const subqueryProblems: ProblemDefinition[] = [
 {
  id: 'subquery-easy-1',
  title: 'Employees Earning Above Average',
  statement: `Write a query to find the **first name**, **last name**, and **salary** of all employees who earn more than the overall average salary.\n\nUse a subquery to calculate the average salary.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name', 'salary'],
   values: [
    ['Alice', 'Johnson', 95000],
    ['Bob', 'Smith', 88000],
    ['Eva', 'Davis', 78000],
    ['Frank', 'Miller', 92000],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'easy',
  topicTags: ['subqueries'],
  hints: [
   'A scalar subquery returns a single value: (SELECT AVG(salary) FROM employees)',
   'Use this subquery in a WHERE clause: WHERE salary > (SELECT AVG(salary) FROM employees)',
  ],
 },
 {
  id: 'subquery-medium-1',
  title: 'Employees in Engineering via Subquery',
  statement: `Write a query to find the **first name** and **last name** of all employees who work in the Engineering department.\n\nUse a subquery with **IN** to find the department ID instead of a JOIN.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['first_name', 'last_name'],
   values: [
    ['Alice', 'Johnson'],
    ['Bob', 'Smith'],
    ['Frank', 'Miller'],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'medium',
  topicTags: ['subqueries'],
  hints: [
   'Use a subquery to get the department ID: (SELECT id FROM departments WHERE name = \'Engineering\')',
   'Then filter employees: WHERE dept_id IN (subquery)',
  ],
 },
 {
  id: 'subquery-medium-2',
  title: 'Departments with Their Highest Earner',
  statement: `Write a query to return each **department name** and the **highest salary** in that department (aliased as \`top_salary\`).\n\nUse a correlated subquery or a JOIN with a subquery to find the maximum salary per department. Only include departments that have at least one employee.`,
  schemaDDL,
  seedDML,
  expectedOutput: {
   columns: ['name', 'top_salary'],
   values: [
    ['Engineering', 95000],
    ['Sales', 72000],
    ['Marketing', 78000],
    ['HR', 67000],
   ],
  },
  comparisonMode: 'order-insensitive',
  difficulty: 'medium',
  topicTags: ['subqueries'],
  hints: [
   'A correlated subquery references the outer query: (SELECT MAX(salary) FROM employees WHERE dept_id = d.id)',
   'Alternatively, use a JOIN: JOIN (SELECT dept_id, MAX(salary) as top_salary FROM employees GROUP BY dept_id) ...',
   'Make sure to filter out departments with no employees.',
  ],
 },
];
